<template>
  <div class="bar_chart section mx-auto px-0 mt-5">
    <span style="float: left">จำนวนรายการพืช</span>
    <canvas id="bar" ref="bar"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import { mapState } from "vuex";

export default {
  name: "bar_chart",
  computed: {
    ...mapState({
      bar_chart: (state) => {
        return state.dashboardModule.bar_chart;
      },
    }),
  },
  methods: {
    createChart() {
      // responsive: false,
      //   scales: {
      //   yAxes: [{
      //     stacked: true,
      //     gridLines: {
      //       display: true,
      //       color: "rgba(255,99,132,0.2)"
      //     }
      //   }],
      //     xAxes: [{
      //     gridLines: {
      //       display: false
      //     }
      //   }]
      // }
      const ctx = document.getElementById("bar");
      this.chart = new Chart(ctx, {
        type: "bar",
        options: {
          responsive: false,
          maintainAspectRatio: false,
          aspectRatio: 1,
          scales: {
            yAxes: [
              {
                stacked: true,
                gridLines: {
                  display: true,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          legend: {
            display: false,
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem) =>
                `${tooltipItem.yLabel}: ${tooltipItem.xLabel}`,
              title: () => null,
            },
          },
        },
        data: {
          labels: this.labels,
          datasets: [
            {
              data: this.bar_chart,
              backgroundColor: this.backgroundColor,
              barThickness: 60,
            },
          ],
        },
      });
    },
    updateValue(value) {
      this.chart.data.datasets[0].data[0] = value[0];
      this.chart.data.datasets[0].data[1] = value[1];
      this.chart.update();
    },
  },
  mounted: function () {
    this.createChart();
    this.$store.watch(
      (state) => {
        return state.dashboardModule.bar_chart;
      },
      (newValue, oldValue) => {
        this.updateValue(newValue);
      }
    );
  },
  data() {
    return {
      backgroundColor: ["#DB7F50", "#41634A"],
      labels: ["แปลงสำรวจ", "แปลงธนาคาร"],
      chart: "",
    };
  },
};
</script>

<style scoped>
canvas {
  /*width: 95% !important;*/
  /*margin: auto;*/
  /*height: 300px !important;*/
}
#bar {
  /*margin: auto !important;*/
  /*width: 100% !important;*/
  /*height: 45vh !important;*/
}
</style>
